/**
 * Created by Mohamed on 5/2/2016.
 */
(function(angular) {

    // Should be set when service injection
    var _instance;
    var _emitter;
    var _activeScope

    var open = function() {
        $("body").addClass("side-bar-open");
        _emitter.triggerSync("change", $("body").hasClass("side-bar-open"));
    };

    var close = function() {
        $("body").removeClass("side-bar-open");
        _emitter.triggerSync("change", $("body").hasClass("side-bar-open"));
    };

    var toggle = function() {
        $("body").toggleClass("side-bar-open");
        _emitter.triggerSync("change", $("body").hasClass("side-bar-open"));
    };

	//Sidebar status
	var isOpened = function() {
		return $("body").hasClass("side-bar-open");
	};

	var isClosed = function() {
		return !$("body").hasClass("side-bar-open");
	};

	var TSSideBarService = function() {
        var self = this;
        _emitter = JarEventEmitter.call(self);

        self.open = open;
        self.close = close;
        self.toggle = toggle;
        self.isOpened = isOpened;
        self.isClosed = isClosed;

        self.onChange = function(callback) {
            // Return the information of the handler
            return self.on("change", callback);
        };
    };

    angular
        .module('harriApp')
        .service('TSSideBarService', function () {
            return function () {
                if (!_instance) {
                    _instance = new TSSideBarService()
                }

                return _instance;
            }
        });

})(angular);